import React, { useEffect } from 'react';
import { useGetDeviceType } from 'src/hooks/useGetDeviceType';
import classNames from 'classnames';
import { useWidgetDndContextData } from '@/context/WidgetDndContext';
import { SECTION_TYPE } from 'src/components/WidgetMaker/WidgetDnD/WidgetProperties/FooterBuilder/constant';
import { fetchFooterPaymentModesList } from 'src/redux/actions';
import { useDispatch } from 'react-redux';
import { useSSRSelector } from 'src/redux';
import { getFooterDSLabel } from 'src/components/DesignSystem/Footers/footerUtils';

export function CopyrightAndPayment({ textColor, isFooterInView }) {
  const dispatch = useDispatch();
  const { deviceType } = useGetDeviceType();
  const isMobile = deviceType === 'mobile';
  const {
    widgetContextState: { activeFooterData, globalStyle },
  } = useWidgetDndContextData();
  const { footerPaymentModesList, storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
    footerPaymentModesList: state.commonReducer.footerPaymentModesList,
  }));

  const storeId = storeData?.store_id;

  const globalBorderRadius = Number(
    globalStyle?.imageCards?.style?.borderRadius?.replace('px !important', '')
  );

  const componentData = Object.values(activeFooterData?.footerPropsConfig || {})?.find(
    (item) => item?.isStaticSection
  )?.builder;

  useEffect(() => {
    if (isFooterInView && !footerPaymentModesList?.length && storeId) {
      dispatch(fetchFooterPaymentModesList(storeId));
    }
  }, [isFooterInView, footerPaymentModesList, storeId]);

  if (!componentData) {
    return null;
  }
  return (
    <div
      className={classNames(
        'tw-flex tw-items-center',
        isMobile
          ? 'tw-flex-col tw-items-center tw-justify-center tw-gap-[24px] tw-px-[20px] tw-py-[32px]'
          : 'tw-flex-row tw-justify-between tw-gap-[100px] tw-px-[40px] tw-py-[21.75px]'
      )}
      style={{
        borderTop: '0.7px solid rgba(255,255,255,0.3)',
      }}
    >
      {componentData?.map((staticLayer, index) => {
        if (staticLayer?.isVisible && staticLayer.type === SECTION_TYPE.COPYRIGHT) {
          return (
            <div
              key={index}
              className={`tw-flex tw-items-center ${isMobile ? 'tw-flex-col' : ''}`}
            >
              <p
                key={staticLayer.type}
                className={classNames(
                  'tw-m-0 tw-whitespace-nowrap tw-font-normal',
                  !isMobile
                    ? 'tw-mr-[4px] tw-text-[12px] tw-leading-[16.8px]'
                    : 'tw-text-[10px]  tw-leading-[14.8px]'
                )}
                style={{ color: textColor }}
              >
                {`${staticLayer?.content}.`}
              </p>
              <div className={`tw-flex tw-items-center ${isMobile ? 'tw-mt-[6px]' : ''}`}>
                <div
                  className={
                    !isMobile
                      ? 'tw-mr-[2px] tw-text-[12px] tw-leading-[16.8px]'
                      : 'tw-mr-[2px] tw-text-[10px]  tw-leading-[14.8px] '
                  }
                >
                  {getFooterDSLabel({
                    configs: storeData?.configs,
                    customStyles: {
                      color: textColor,
                    },
                  })}
                </div>
              </div>
            </div>
          );
        }
        if (
          staticLayer?.isVisible &&
          staticLayer.type === SECTION_TYPE.PAYMENT_MODES &&
          !!footerPaymentModesList?.length
        ) {
          return (
            <div
              key={staticLayer.type}
              className="tw-flex tw-flex-wrap tw-items-center tw-gap-[4px]"
            >
              {footerPaymentModesList.map((imageCDN) => {
                return (
                  <div
                    style={{
                      borderRadius: globalBorderRadius >= 5 ? '5px' : globalBorderRadius,
                    }}
                    key={imageCDN}
                    className={`
                      tw-h-[24px] tw-w-[40px] tw-overflow-hidden tw-rounded-[3px] tw-border-[1px]  tw-border-solid tw-border-[#E2E4E7]
                      ${globalBorderRadius > 5 ? 'removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer' : ''}
                      `}
                  >
                    <img
                      src={imageCDN}
                      className={`removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer tw-h-[100%] tw-w-[100%]`}
                    />
                  </div>
                );
              })}
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}
